@if (roleTask) {
    <div class="row">
        <div class="col-12 col-md-6 col-xl-7">
            <h3>Description</h3>
            @if (roleTask.supplementaryData?.description) {
                <div [froalaView]="roleTask.supplementaryData!.description"></div>
            } @else {
                <adapt-call-to-action-inline>
                    <p>(There are currently no description for this role task)</p>
                    @if (isEditing) {
                        <button adaptCallToActionButton
                                adaptButtonIcon="edit"
                                [adaptBlockingClick]="editRoleTask">Describe your role task</button>
                    }
                </adapt-call-to-action-inline>
            }
        </div>
        <div class="col-12 col-md-6 col-xl-5">
            <div class="mb-3">
                <h3>Role</h3>
                <adapt-link-role [role]="roleTask.role"
                                 [showIcon]="true"></adapt-link-role>
            </div>
            @if (roleTask.supplementaryData?.guidanceQuestions) {
                <div class="mb-3">
                    <h3>Guidance Questions</h3>
                    <div [froalaView]="roleTask.supplementaryData!.guidanceQuestions"></div>
                </div>
            }
            @if (guidanceMaterials.length > 0) {
                <h3>Guidance Materials</h3>
                <div class="guidance-material-list">
                    <ul>
                        @for (guidanceMaterial of guidanceMaterials; track guidanceMaterial) {
                            <li>
                                <adapt-display-guidance-material [guidanceMaterial]="guidanceMaterial"></adapt-display-guidance-material>
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>
    </div>
}
